import { region } from './locale_util';
import {
  TRANSPORTATION_TYPE_DRIVING,
  TRANSPORTATION_TYPE_TRANSIT,
  TRANSPORTATION_TYPE_WALKING,
  TRANSPORTATION_TYPE_TRANSIT_FROM_WEB,
  TRANSPORTATION_TYPE_DRIVING_FROM_WEB,
  TRANSPORTATION_TYPE_WALKING_FROM_WEB,
  TRANSPORTATION_TYPE_OSRM_DRIVING,
  TRANSPORTATION_TYPE_OSRM_WALKING,
} from './constants';

// magic number for directions
const APPROXIMATE_DRIVING_DISTANCE_PER_SECOND = 11.0;
const APPROXIMATE_TRANSIT_DISTANCE_PER_SECOND = 8.0;
const APPROXIMATE_WALKING_DISTANCE_PER_SECOND = 0.4;

const formattedKms = m => ({ km: parseInt(m / 1000, 10), m: m % 1000 });

const formattedMiles = m => {
  const num = Number((m / 1000) * 0.621371192);
  return num.toFixed(2);
};

const isMetric = () => {
  const regionValue = region().toLowerCase();
  if (regionValue === 'ja' || regionValue === 'tw' || regionValue === 'kr') {
    return true;
  }
  return false;
};

const setDistance = (lat1, lon1, lat2, lon2) => {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  }

  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * lat2) / 180;
  const theta = lon1 - lon2;
  const radtheta = (Math.PI * theta) / 180;
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist *= 1.609344;

  return dist;
};

const coordinateToDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // km (change this constant to get miles)
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return Math.round(d * 1000);
};

const distanceToAppromateTransportationTime = (distance, type) => {
  if (
    type === TRANSPORTATION_TYPE_DRIVING ||
    type === TRANSPORTATION_TYPE_DRIVING_FROM_WEB ||
    type === TRANSPORTATION_TYPE_OSRM_DRIVING
  ) {
    return distance < APPROXIMATE_DRIVING_DISTANCE_PER_SECOND
      ? '0'
      : parseInt(
          distance / APPROXIMATE_DRIVING_DISTANCE_PER_SECOND,
          10,
        ).toString();
  }

  if (
    type === TRANSPORTATION_TYPE_WALKING ||
    type === TRANSPORTATION_TYPE_WALKING_FROM_WEB ||
    type === TRANSPORTATION_TYPE_OSRM_WALKING
  ) {
    return distance < APPROXIMATE_WALKING_DISTANCE_PER_SECOND
      ? '0'
      : parseInt(
          distance / APPROXIMATE_WALKING_DISTANCE_PER_SECOND,
          10,
        ).toString();
  }

  if (
    type === TRANSPORTATION_TYPE_TRANSIT ||
    type === TRANSPORTATION_TYPE_TRANSIT_FROM_WEB
  ) {
    return distance < APPROXIMATE_TRANSIT_DISTANCE_PER_SECOND
      ? '0'
      : parseInt(
          distance / APPROXIMATE_TRANSIT_DISTANCE_PER_SECOND,
          10,
        ).toString();
  }

  return '0';
};

const setUserDistance = (localLocation, itemLocation) => {
  const localation = localLocation.split(',');
  const userLng = localation[0];
  const userLat = localation[1];
  const itemLng = itemLocation.lng;
  const itemLat = itemLocation.lat;

  const distance = setDistance(userLat, userLng, itemLat, itemLng);
  return Math.round(distance);
};

export {
  formattedKms,
  formattedMiles,
  isMetric,
  coordinateToDistance,
  distanceToAppromateTransportationTime,
  setDistance,
  setUserDistance,
};
